import React from "react";
import { GridItem, Image, SimpleGrid, Text, Box } from "@chakra-ui/react";

import { useIsMobile } from "../default/ResponsiveUtils";
import bA1 from "../images/bA1.jpg";
import bA2 from "../images/bA2.jpg";

function BeforeAndAfter() {
  const isMobile = useIsMobile();

  return (
    <SimpleGrid
      pb={isMobile ? 10 : 5}
      pt={5}
      columns={isMobile ? 1 : 2}
      margin="auto"
      spacing={12}
    >
      <SimpleGrid columns={1}>
        <GridItem align="center" pb={isMobile ? 2 : 7}>
          <Box bg="#c2eaf0" borderRadius={2} border="2px solid #44838d">
            <Text
              fontSize={isMobile ? 22 : 30}
              fontWeight="bold"
              fontFamily="serif"
              textColor="#104d57"
            >
              Белење заби трансформација
            </Text>
          </Box>
        </GridItem>
        <GridItem align="center">
          <Image
            border="6px solid white"
            src={bA1}
            width={isMobile ? "22rem" : "28rem"}
            height="24rem"
            style={{ boxShadow: "1px 2px 4px 2px rgba(0, 0, 0, 0.3)" }}
          />
        </GridItem>
      </SimpleGrid>
      <SimpleGrid columns={1}>
        <GridItem align="center" pb={isMobile ? 2 : 7}>
          <Box bg="#c2eaf0" borderRadius={2} border="2px solid #44838d">
            <Text
              fontSize={isMobile ? 22 : 30}
              fontWeight="bold"
              fontFamily="serif"
              textColor="#104d57"
            >
              Белење заби трансформација
            </Text>
          </Box>
        </GridItem>
        <GridItem align="center">
          <Image
            border="6px solid white"
            src={bA2}
            width={isMobile ? "22rem" : "28rem"}
            height="24rem"
            style={{ boxShadow: "1px 2px 4px 2px rgba(0, 0, 0, 0.3)" }}
          />
        </GridItem>
      </SimpleGrid>
    </SimpleGrid>
  );
}

export default BeforeAndAfter;
